export const DraggableTabsOrdering = {
    initialOrder: 0,
    validateSpot: (state, docked, spot) => {
        const tabKeys = Object.keys(state.tabs);
        const lockedTabsCount = tabKeys.filter((x) => state.tabs[x].locked).length;
        const dockedTabsCount = state.dockedTabKeys.length;
        if (docked) {
            if (spot < tabKeys.length - dockedTabsCount) {
                throw "Invalid spot";
            }
            else if (spot > tabKeys.length + 1) {
                throw "Invalid spot";
            }
        }
        else {
            if (spot < lockedTabsCount) {
                throw "Invalid spot";
            }
            else if (spot > tabKeys.length - dockedTabsCount + 1) {
                throw "Invalid spot";
            }
        }
    },
    createSpot: (state, docked, spot) => {
        const tabKeys = Object.keys(state.tabs);
        const totalTabsCount = tabKeys.length;
        const dockedTabsCount = state.dockedTabKeys.length;
        if (spot) {
            DraggableTabsOrdering.validateSpot(state, docked, spot);
            Object.entries(state.tabs).forEach(([key, tab]) => {
                if (tab.order >= spot) {
                    tab.order += 1;
                }
            });
            return spot;
        }
        if (docked) {
            return totalTabsCount;
        }
        else {
            Object.entries(state.tabs).forEach(([key, tab]) => {
                if (state.dockedTabKeys.includes(key)) {
                    tab.order += 1;
                }
            });
            return totalTabsCount - dockedTabsCount;
        }
    },
    undock: (state, tabKey) => {
        Object.entries(state.tabs).forEach(([key, tab]) => {
            if (state.dockedTabKeys.includes(key) &&
                tab.order < state.tabs[tabKey].order) {
                tab.order += 1;
            }
        });
        const lockedTabs = Object.values(state.tabs).filter((tab) => !tab.dockable && tab.locked).length;
        state.tabs[tabKey].order = Math.max(getAllTabsCount(state) - state.dockedTabKeys.length, lockedTabs);
    },
    dock: (state, tabKey) => {
        Object.values(state.tabs).forEach((tab) => {
            if (tab.order > state.tabs[tabKey].order) {
                tab.order -= 1;
            }
        });
        state.tabs[tabKey].order = getAllTabsCount(state) - 1;
    },
    remove: (state, key) => {
        Object.values(state.tabs).forEach((tab) => {
            if (tab.order > state.tabs[key].order) {
                tab.order -= 1;
            }
        });
    },
    reorder: (state, action) => {
        if (state.dockedTabKeys.includes(action.payload.key)) {
            const offset = Object.keys(state.tabs).length - state.dockedTabKeys.length;
            action.payload.destination += offset;
            action.payload.source += offset;
        }
        if (action.payload.source < action.payload.destination) {
            for (let index = action.payload.source + 1; index <= action.payload.destination; index++) {
                const [key] = findByIndex(state, index);
                state.tabs[key].order -= 1;
            }
        }
        else {
            for (let index = action.payload.source - 1; index >= action.payload.destination; index--) {
                const [key] = findByIndex(state, index);
                state.tabs[key].order += 1;
            }
        }
        state.tabs[action.payload.key].order = action.payload.destination;
    },
};
const getAllTabsCount = (state) => Object.keys(state.tabs).length;
const findByIndex = (state, index) => Object.entries(state.tabs).find((x) => x[1].order === index);
